<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'button-boxes',
          title: 'Button boxes',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: 'ri:service-line',
          icon_color: 'revinre',
          h2: 'How would you like to list your property?',
          h2_color: '',
          h2_desc: 'Listing your property on the MLS can be a difficult task. REVINRE is here to help simplify the process as much as possible. You can start with the basics for free and purchase additional services as needed, or you can start off picking exactly what you need from the start.',
          h2_desc_color: '',
          pre_btn: [],
          options: [
            {
              bg_color: '',
              border_size: 0,
              border_color: '',
              image: 'https://s3.revinre.net/perm/revinre/Sell on your own.png',
              image_alt: 'Sell on your own',
              title: 'Sell on your own',
              title_color: '',
              desc: 'Are you confident listing your property on your own and handling all of the paperwork? We offer the option of listing your home for free on the MLS. With this option you can also purchase services as you need them including upgrading to "contract-to-close" or "full service" where we handle the paperwork and price negotiations.',
              desc_color: '',
              btn_color: 'revinre',
              btn_full_width: 0,
              btn_pre_icon: '',
              btn_text: 'Get started',
              btn_post_icon: '',
              btn_url: '/my-listings',
              btn2_color: '',
              btn2_full_width: 0,
              btn2_pre_icon: '',
              btn2_text: '',
              btn2_post_icon: '',
              btn2_url: '',
            },
            {
              bg_color: '',
              border_size: 0,
              border_color: '',
              image: 'https://s3.revinre.net/perm/revinre/Sell with help.jpg',
              image_alt: 'Sell with help',
              title: 'Sell with help',
              title_color: '',
              desc: 'If you would prefer we handle paperwork, deadlines and price negotiations you have the option of purchasing our "contract-to-close" service or one of our packages including this service. Our experienced brokers will guide you through the entire process and work hard to get you the best price for your home.',
              desc_color: '',
              btn_color: 'revinre',
              btn_full_width: 0,
              btn_pre_icon: '',
              btn_text: 'Get started',
              btn_post_icon: '',
              btn_url: '/my-listings',
              btn2_color: '',
              btn2_full_width: 0,
              btn2_pre_icon: '',
              btn2_text: '',
              btn2_post_icon: '',
              btn2_url: '',
            },
            {
              bg_color: '',
              border_size: 0,
              border_color: '',
              image: 'https://s3.revinre.net/perm/revinre/Sell with an agent.png',
              image_alt: 'Sell with an agent',
              title: 'Sell with an agent',
              title_color: '',
              desc: 'Full agent representation is a traditional commission based process. We will handle everything from showings, paperwork, deadlines, price negotiations, MLS entry and much more. You can also upgrade to this option at any point in the "sell on your own" and "sell with help" options with the costs spent discounted.',
              desc_color: '',
              btn_color: 'revinre',
              btn_full_width: 0,
              btn_pre_icon: '',
              btn_text: 'Get started',
              btn_post_icon: '',
              btn_url: '/full-service',
              btn2_color: '',
              btn2_full_width: 0,
              btn2_pre_icon: '',
              btn2_text: '',
              btn2_post_icon: '',
              btn2_url: '',
            },
          ],
          post_btn: [],
        },
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }
      if(!this.pc.options) { this.pc.options = []; this.$forceUpdate(); }
    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Button boxes :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.options">
            <transition-group tag="div">
              <div v-for="(option, option_i) in pc.options" :key="'f2'+option_i" class="border-bottom border-light py-4">
                <div class="row">
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String List, Single" v-model="option.bg_color" Title="Background color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="Number" v-model="option.border_size" Title="Border size : " Min="0" Max="10"></w-field>
                  </div>
                  <div class="col">
                    <w-field SimpleDataType="String List, Single" v-model="option.border_color" Title="Border color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.options.splice(option_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <w-field SimpleDataType="String" v-model="option.image" Title="Image :"></w-field>
                  </div>
                  <div class="col-sm-6">
                    <w-field SimpleDataType="String" v-model="option.image_alt" Title="Image ALT text :"></w-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.title" Title="Title :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.title_color" Title="Title color : " :Options="theme_colors"></w-field>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn_color" Title="Button color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn_full_width" Title="Button full width : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn_pre_icon" Title="Button pre icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn_text" Title="Button text :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn_post_icon" Title="Button post icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn_url" Title="Button URL :"></w-field>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn2_color" Title="Button 2 color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn2_full_width" Title="Button 2 full width : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn2_pre_icon" Title="Button 2 pre icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn2_text" Title="Button 2 text :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn2_post_icon" Title="Button 2 post icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn2_url" Title="Button 2 URL :"></w-field>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.desc_color" Title="Description color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-sm-12">
                    <label>Description :</label>
                    <CkRichEditor v-model="option.desc"></CkRichEditor>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.options.push({bg_color: '', border_size: 0, border_color: '', image: '', image_alt: '', title: '', title_color: '', desc: '', desc_color: '', btn_color: '', btn_full_width: 0, btn_pre_icon: '', btn_text: '', btn_post_icon: '', btn_url: '', btn2_color: '', btn2_full_width: 0, btn2_pre_icon: '', btn2_text: '', btn2_post_icon: '', btn2_url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add box</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div v-if="pc['icon'] || pc['h2'] || pc['h2_desc']" class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" class="text-pre-wrap" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div class="row justify-content-center">
          <div v-for="(option, option_i) in pc['options']" :key="option_i" class="col _w-n-255 _w-m-480 mb-4" :class="pc['options'] && pc['options'].length < 3 ? 'mx-sm-5' : ''">
            <div class="card grow text-center h-100" :class="'bg-'+option['bg_color']+(option['border_size'] ? ' border _b-s-'+option['border_size']+' border-'+option['border_color'] : '')">
              <div v-if="option['image']" class="px-6 pt-5">
                <img data-aos="fade-zoom-in" :src="formatImage(option['image'])" :alt="option['image_alt']" class="img-fluid mx-auto d-block">
              </div>
              <div class="p-4">
                <h3 v-if="option['title']" class="h2 mb-3" :class="'text-'+option['title_color']" data-aos="fade-zoom-in">{{option['title']}}</h3>
                <div v-if="option['desc']" class="mb-4 text-left" v-html="option['desc']"></div>

                <a v-if="option['btn_text'] || option['btn_pre_icon'] || option['btn_post_icon']" :href="option['btn_url']" class="btn btn-lg" :class="'btn-'+option['btn_color']+(option['btn_full_width'] ? ' btn-block' : '')">
                  <Icon v-if="option['btn_pre_icon']" :icon="option['btn_pre_icon']" height="20"></Icon>
                  <span v-if="option['btn_pre_icon'] && option['btn_text']" class="border-left mx-3"></span>
                  {{ option['btn_text'] }}
                  <span v-if="option['btn_post_icon'] && option['btn_text']" class="border-left mx-3"></span>
                  <Icon v-if="option['btn_post_icon']" :icon="option['btn_post_icon']" height="20"></Icon>
                </a>
                <a v-if="option['btn2_text'] || option['btn2_pre_icon'] || option['btn2_post_icon']" :href="option['btn2_url']" class="btn btn-lg" :class="'btn-'+option['btn2_color']+(option['btn2_full_width'] ? ' btn-block' : '')+((option['btn_text'] || option['btn_pre_icon'] || option['btn_post_icon']) && !option['btn2_full_width'] ? ' ml-3' : '')">
                  <Icon v-if="option['btn2_pre_icon']" :icon="option['btn2_pre_icon']" height="20"></Icon>
                  <span v-if="option['btn2_pre_icon'] && option['btn2_text']" class="border-left mx-3"></span>
                  {{ option['btn2_text'] }}
                  <span v-if="option['btn2_post_icon'] && option['btn2_text']" class="border-left mx-3"></span>
                  <Icon v-if="option['btn2_post_icon']" :icon="option['btn2_post_icon']" height="20"></Icon>
                </a>
                  
              </div>
            </div>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center mt-5">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
